<template>
  <div class="flex flex_col chongq-page">
    <!-- 上面的选择 -->
    <div class="selects">
      <el-form
        :model="queryParam"
        ref="ruleform"
        :inline="true"
        class="flex flex_ju_sb warnform-inline"
      >
        <div class="form-inputs">
          <el-form-item label="设备名称">
            <el-select
              :placeholder="orgSelect.length ? '请选择' : '暂无设备'"
              v-model="queryParam.deviceCode"
            >
              <el-option
                v-for="(item, index) in orgSelect"
                :key="index"
                :value="item.deviceCode"
                :label="item.deviceName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" class="form-picker">
            <div class="picker-divs picker-divs-more">
              <el-date-picker
                v-model="queryParam.startTime"
                size="small"
                type="datetime"
                placeholder="选择时间"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions0"
                :editable="false"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
              <i class="pick-icon-yuan el-icon-time"></i>
            </div>
          </el-form-item>
          <el-form-item label="结束时间" class="form-picker">
            <div class="picker-divs picker-divs-more">
              <el-date-picker
                v-model="queryParam.endTime"
                size="small"
                type="datetime"
                placeholder="选择时间"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions1"
                :editable="false"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
              <i class="pick-icon-yuan el-icon-time"></i>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="form-btns">
          <el-button type="primary" @click="searchClick_">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 虫情图片 -->
    <div class="bottom-content cq-imgs" v-if="isorgSelectData">
      <div class="table-title bold">虫情图片</div>
      <!-- 图片列表 -->
      <div class="imgs-wrap" v-loading="imgLoading">
        <!-- <i class="el-icon-loading" v-show="nowJiazai"></i> -->
        <ul
          class="imgs-uil infinite-list-wrapper"
          v-if="isimgListData"
          v-infinite-scroll="imgload"
          infinite-scroll-disabled="imgIsNoMore"
          :infinite-scroll-immediate-check="false"
        >
          <li class="imgs-li" v-for="(item, index) in imgListData" :key="index">
            <el-image
              class="cq-img"
              :src="item.blastPicture"
              lazy
              v-image-preview="item.blastPicture"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="font_16 cqimg-time">{{ item.photoTime }}</div>
          </li>
        </ul>

        <div class="table-empty bottom-empty empty-img" v-else>
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无虫情图片</div>
        </div>
      </div>
    </div>
    <!-- 虫情统计 -->
    <div class="flex flex_col bottom-content cq-bottom" v-if="isorgSelectData">
      <title-model class="cq-b-title" titles="虫情统计" heights="51">
        <div
          class="flex flex_a_c flex_ju_c c_white font_14 cursor btn-change"
          @click="chartTableSwitch"
        >
          <img
            :src="
              !isEchart
                ? require('@/assets/image/monitor/icon_chart.png')
                : require('@/assets/image/monitor/icon_table.png')
            "
            alt=""
          />
          <span>{{ isEchart ? "报表切换" : "图表切换" }}</span>
        </div>
      </title-model>
      <div
        class="
          table-empty
          bottom-empty
          flex flex_col flex_a_c flex_ju_c
          empty-img
        "
        v-if="isEchart && !isShowChart"
      >
        <img
          class="table-noimg"
          src="@/assets/image/home/img_none.png"
          alt=""
        />
        <div class="table-emptyword">暂无虫情数据</div>
      </div>
      <div class="flex flex_a_c cq-charts" v-show="isEchart && isShowChart">
        <!-- 左边折线图 -->
        <div class="cqchart-line" ref="cqlines"></div>
        <!-- 右边饼图 -->
        <div class="cqchart-pie" id="cqPie" ref="cqPie"></div>
      </div>
      <!-- table表格 -->
      <div class="table-content" v-show="!isEchart">
        <div class="warn-tables cq-tables" v-if="tableData.length">
          <el-table
            :data="tableData"
            class="tables"
            :height="248"
            :stripe="true"
            align="center"
            header-cell-class-name="header-cell"
            cell-class-name="table-cell"
          >
            <el-table-column
              type="index"
              label="序号"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column label="时间" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span
                  v-if="scope.row.insectDate && scope.row.insectDate.length"
                  >{{ scope.row.insectDate.slice(0, 10) }}</span
                >
                <span v-else>--</span>
              </template>
            </el-table-column>
            <!-- 动态显示虫子类型 -->
            <el-table-column
              :label="item"
              align="center"
              show-overflow-tooltip
              v-for="(item, index) in tableCTypes"
              :key="index"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.tableList[item] && scope.row.tableList[item] > 0
                  "
                  >{{ scope.row.tableList[item] }}只</span
                >
                <span v-else>--</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="pagination"
            layout="prev, pager, next"
            :page-size="ipagination.pageSize"
            :total="ipagination.total"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
        <!-- 占位数据 -->
        <div
          class="table-empty flex flex_col flex_a_c flex_ju_c bottom-empty"
          v-else
        >
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无虫情数据</div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="table-empty bottom-empty cq-empty flex flex_a_c flex_col flex_ju_c"
    >
      <img class="table-noimg" src="@/assets/image/sf/empty.png" alt="" />
      <div class="table-emptyword">该网点暂无虫情设备！</div>
    </div>
  </div>
</template>

<script>
/**
 * @description 虫情监测
 * 1. 时间初始化：近三天（不包含今天）的时间范围
 */
import titleModel from "@/components/title-model.vue";
import tableMinin from "@/mixins/TableMinin";
import chongqJs from "./lib/chongq";
import {
  prevDayTime,
  GetPreMonthDay,
  GetNextMonthDay,
  getFormatDate,
} from "../../times/moment";

export default {
  components: { titleModel },
  mixins: [tableMinin, chongqJs],
  data() {
    return {
      orgAllSelect: [], // 生产区域下拉选
      allOrgId: "", /// 分公司下面选中的orgid

      orgSelect: [], // 上面的下拉选数据
      isorgSelectData: true, //上面的下拉选数据是否有数据
      imgListData: [], // 图片数据
      isimgListData: true, //是否有图片数据
      tableCTypes: [], // 表格的虫子类型，主要用于头部动态虫子的显示
      isEchart: false, // 显示的是否是图表  false 的情况下展示的是table
      isMakeTime: false, // 是否需要初始化时间：限制公共的时间初始化
      ifUseLoadBack: false, // 是否使用loadData公用的返回数据赋值
      url: {
        list: "/napi/index/insectDataReport",
        imgs: "/sys/xb/insect/findDevicePictureByDeviceCode",
        chart: "/napi/index/insectDataChart",
      },
      imgLoading: false, // 图片加载中状态
      disableMixinCreated: true,
      isShowChart: false, // 是否显示图表，即图表是否有数据
      imagePicGun: false,
      imgswitch: true,
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
      imgPageNum: 0,
      imgPageSize: 24,
      imgIsNoMore: false,
      loadIndex: 0,
      nowJiazai: false,
      imgTotal: 1, // 图片的总数量
    };
  },
  created() {
    // 时间赋值
    // this.$set(this.queryParam, 'deviceCode', 'G95799398')
    this.$set(this.queryParam, "startTime", `${prevDayTime(3)} 00:00:00`);
    this.$set(this.queryParam, "endTime", `${prevDayTime(1)} 23:59:59`);
  },
  mounted() {
    // 获取设备编码下拉选
    this.getOrgids();
    // this.lineChart()
    // this.peiChart()
    // 本页面时间初始化
    // 获取图片数据
    // this.getImgList()
    // 获取统计报表
    // this.loadData()
    // 获取右侧饼图数据
    // this.getPieData()
  },
};
</script>
<style lang="scss" scoped>
.chongq-page {
  height: 100%;
  min-height: 670px;
  // 时间选择框
  .warnform-inline {
    .form-picker {
      .picker-div {
        width: 3rem;
      }
    }
  }
  // 下面的内容
  .bottom-content {
    margin-top: 0.15rem;
    background-color: #fff;
    border-radius: 0.19rem;
    .table-title {
      font-size: 0.2rem;
      color: #454545;
      text-align: left;
      padding: 0.25rem 0 0.29rem 0.25rem;
    }
  }
  // 虫情图片
  .cq-imgs {
    padding: 0 0.04rem 0.26rem 0;
    .imgs-wrap {
      position: relative;
      min-height: 1.8rem;
      max-height: 3.6rem;
      padding-left: 0.29rem;
      //   overflow-y: scroll;
      // 背景
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent;
        border-radius: 4px;
      }
      // 背景
      &::-webkit-scrollbar-track {
        width: 8px;
        height: 8px;
        background-color: transparent;
        border-radius: 4px;
      }
      // 滚动条
      &::-webkit-scrollbar-thumb {
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: #d9d9d9;
      }
      .el-icon-loading {
        position: absolute;
        bottom: -20px;
        // left: 50%;
        // transform: translateX(-50px);
      }
      // 图片列表
      .imgsUlGun {
        // max-height: 3.6rem;
        // overflow: scroll;
      }
      .imgs-uil {
        text-align: left;
        max-height: 3.5rem;
        overflow: auto;
        // 背景
        &::-webkit-scrollbar {
          width: 8px;
          height: 0px;
          background-color: transparent;
          border-radius: 4px;
        }
        // 背景
        &::-webkit-scrollbar-track {
          width: 8px;
          height: 8px;
          background-color: transparent;
          border-radius: 4px;
        }
        // 滚动条
        &::-webkit-scrollbar-thumb {
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #d9d9d9;
        }
        .imgs-li {
          width: 11.23%;
          height: 1.61rem;
          background-color: #454545;
          display: inline-block;
          margin-left: 0.25rem;
          position: relative;
          &:nth-child(8n + 1) {
            margin-left: 0;
          }
          &:nth-child(n + 9) {
            margin-top: 0.21rem;
            // margin-bottom: 50px;
          }
        }
        .cq-img {
          cursor: pointer;
          width: 100%;
          height: 100%;
        }
        .cqimg-time {
          width: 100%;
          position: absolute;
          color: #454545;
          bottom: 0.09rem;
          left: 0;
          text-align: center;
        }
      }
    }
    .bottom-empty {
      width: 100%;
      // height: 8.89rem;
      background: #ffffff;
      border-radius: 0.19rem;
      // margin-top: 0.19rem;
      // padding: 0.38rem 0;
      // .table-emptyword {
      // 	color: #c8c8c8;
      // }
    }
    .empty-img {
      .table-noimg {
        width: 2.35rem;
        height: 1.88rem;
      }
    }
  }
  // 虫情统计
  .cq-bottom {
    flex: 1;
    overflow: hidden;
    // padding: 0 0.06rem;
    .cq-b-title {
      margin: 0 0.06rem;
      // height: 0.65rem;
    }
    // 切换按钮
    .btn-change {
      width: 1.45rem;
      height: 0.45rem;
      background-color: #42b5b2;
      border-radius: 0.1rem;
      img {
        width: 0.25rem;
        margin-right: 0.09rem;
      }
    }
    // 图表
    .cq-charts {
      padding: 0 0.06rem;
      height: calc(100% - 0.65rem);
      text-align: left;
      // 折线图
      .cqchart-line {
        width: 13rem;
        height: 100%;
      }
      .cqchart-pie {
        width: 6rem;
        height: 88%;
      }
    }
    .table-content {
      height: calc(100% - 0.65rem);
    }
    // 表格
    .cq-tables {
      margin-top: 0;
      padding-bottom: 0.14rem;
      .tables {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }

  // 分页
  .pagination {
    padding-top: 0.14rem;
  }

  // 空数据
  .bottom-empty {
    width: 100%;
    height: 100%;
    // height: calc(100vh - 8rem);
    // height: 3.64rem;
    background: #ffffff;
    border-radius: 0.19rem;
    // margin-top: 0.19rem;
    padding: 0.34rem 0;
    .table-noimg {
      width: 2.35rem;
      height: 1.88rem;
    }
    .table-emptyword {
      color: #797979;
      font-size: 0.17rem;
    }
    &.empty-img {
      padding: 0 !important;
      height: calc(100% - 0.65rem);
    }
  }
  .cq-empty {
    // height: calc(100vh - 8rem) !important;
    // height: 89.8%;
    flex: 1;
    margin-top: 0.15rem;
    .table-noimg {
      width: 4.1rem;
      height: 2.27rem;
    }
    .table-emptyword {
      margin-top: 0.75rem;
      margin-left: 0;
      // color: #c8c8c8;
      font-size: 0.17rem;
    }
  }
}
</style>
